import * as Yup from 'yup';
import { personInfoSelfDescribeValue } from '../../../global/validation-schemas/account-information-form-validation';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { ClergyBioChurchReportingFormModel } from './model.ts/form-model';

export function ConstructPayload(values: ClergyBioChurchReportingFormModel) {
	return {
		reporting: {
			race_ethnicities: values?.race_ethnicities?.filter(r => r !== personInfoSelfDescribeValue)?.map(r => { return { value: r }; }).concat(values?.race_ethnicities?.includes(personInfoSelfDescribeValue) && values?.ethnicitySpecify && [{ value: values?.ethnicitySpecify }]),
			sexual_orientations: values?.sexual_orientations?.filter(s => s !== personInfoSelfDescribeValue)?.map(s => { return { value: s }; }).concat(values?.sexual_orientations?.includes(personInfoSelfDescribeValue) && values?.sexualSpecify && [{ value: values?.sexualSpecify }]),
			gender_identities: values?.gender_identities?.filter(g => g !== personInfoSelfDescribeValue)?.map(g => { return { value: g }; }).concat(values?.gender_identities?.includes(personInfoSelfDescribeValue) && values?.genderSpecify && [{ value: values?.genderSpecify }]),
		},
	};
}

export function GetClergyBioChurchReportingValidationSchema(settings: ClergyBioSettings) {

	return Yup.lazy(({
		race_ethnicities,
		sexual_orientations,
		gender_identities,
	}) => {

		return Yup.object().shape({
			ethnicitySpecify: race_ethnicities?.includes(personInfoSelfDescribeValue) ? Yup.string().nullable().required(settings.ethnicitiesSelfDescribeLabel) : null,
			sexualSpecify: sexual_orientations?.includes(personInfoSelfDescribeValue) ? Yup.string().nullable().required(settings.sexualSelfDescribeLabel) : null,
			genderSpecify: gender_identities?.includes(personInfoSelfDescribeValue) ? Yup.string().nullable().required(settings.genderSelfDescribeLabel) : null,
		});
	});
}